if (!customElements.get('buff-by-you')) {

  class BuffByYou extends HTMLElement {
    constructor() {
        super();

        this.textInput = this.querySelector(".main-product__info__text-property input");
        this.variantSelects = this.querySelectorAll("variant-selects input");
        this.label = this.querySelector(".main-product__bby-image__label-text");
        this.image = this.querySelector('.main-product__bby-image');
        this.filagreePaths = this.image?.querySelectorAll(".bby-filagree > *");
        this.progressBarItems = this.querySelectorAll(".main-product__bby-progress__items__item");

        this.scentCustomNamed = false;

        this.init();
    }

    init() {
      if (this.textInput && this.label) {
        this.textInput.addEventListener('input', (event) => {
          this.updateCustomLabel(event);
        });
      }

      this.setRatingsAndEmojis(true, true);
    }

    setRatingsAndEmojis(setRatings, setEmojis) {
      if (this.variantSelects) {
        let data = JSON.parse(this.querySelector('[type="application/json"][data-type="buff-by-you"]').textContent);

        //complicated alogorithm to find the popularity of a scent on a scale of 1 to 5, with a curve so that the lowest rating is a 2
        if (data){
          
            let minRating = 2;
            let maxRating = 5; 
            let levels = maxRating - minRating; 
            let total = data.length;
            let tierSize = total / levels;

            this.variantSelects.forEach((input) => {
              let scentIndex = data.findIndex(obj => obj.title === input.value);
              if (scentIndex === -1) {
                console.log(`No sales for this product in ${input.value} Scent`);
                scentIndex = Math.round(total / 2);
              }

              if (setRatings) {
                let tier = Math.floor(scentIndex / tierSize);
                let rating = (maxRating - tier - 1) + ((tierSize - (scentIndex % tierSize)) / tierSize);

                input.nextElementSibling.style.setProperty(`--rating`, rating.toFixed(2));
                input.nextElementSibling.classList.add("__rating-loaded");
              }

              if (setEmojis) {
                // console.log(data, scentIndex = Math.round(total / 2))
                input.nextElementSibling.dataset[`emojis`] = data[scentIndex]?.emoji;
              
                /*
                  emojis.forEach((emoji, i) => {
                    const emojis = Array.from(data[scentIndex].emoji);
                    
                  }) 
                */
              }
            });
        }
      }
    }

    disableDoubleScents(variantSelects) {
      let inputs = variantSelects.querySelectorAll("input");
      let checked = Array.from(inputs).find(input => input.checked);
      if (!checked) return;

      let value = checked.value;

      inputs.forEach((input, i) => {
        if (input !== checked && input.value === value) {
          if (input.checked) {
            input.checked = false; // Uncheck the duplicate first
            // Now simulate a user click on the adjacent input
            if (inputs[i + 1]) {
              inputs[i + 1].click();
            } else if (inputs[i - 1]) {
              inputs[i - 1].click();
            }
          }
          input.disabled = true;
        } else {
          input.disabled = false;
        }
      });
    }

    updateTextInput(newValue){
      if (this.scentCustomNamed == false && this.textInput){
        this.textInput.value = newValue;
        this.updateProductFormInputValue();
      }
    }

    updateProductFormInputValue() {
      const productForms =
        document.querySelectorAll(`#Product-Form-${this.dataset.section}, #Installment-${this.dataset.section}`);

      productForms.forEach((productForm) => {
        let input = productForm.querySelector('.main-product__info__text-property__input');

        if (input) {
          input.value = this.textInput.value;
        } else {
          input = this.textInput.cloneNode(true);
          input.setAttribute("type", "hidden");
          productForm.appendChild(input);
        }
        
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    updateFilagree(e){
      if (this.image && this.filagreePaths) {
        let color = this.querySelector(`label[for="${e.target.id}"]`).style.getPropertyValue('--color-scent');
        let position = e.target.dataset.option;
        this.image.style.setProperty(`--color-scent-${position}`, color);
        this.filagreePaths.forEach((path) => {
          if (!path.classList.contains(`__initialized`) && path.classList.contains(`bby-filagree__${position}`)) {
            path.classList.add("__initialized");
          }
        })
      }
    }

    updateProgressBar(e) {
      if (this.progressBarItems) {
        let position = e.target.dataset.option;
        this.progressBarItems[position - 1].classList.remove("__inactive");
        this.progressBarItems[(position - 1) + 3].classList.remove("__inactive");
      }
    }

    updateGeneratedLabel(newValue){
      if (this.scentCustomNamed == false && this.label.textContent !== newValue) {
        const original = this.label.textContent;
        const delay = 50;
        const steps = original.length;

        // Animate deleting each character
        Array.from(this.label.querySelectorAll('span'))
          .reverse()
          .forEach((span, i) => {
            setTimeout(() => {
              span.classList.add("hide");
            }, i * delay);
          });


        // After all characters are removed, set the new text
        setTimeout(() => {
          this.label.innerHTML = Array.from(newValue).map(char => `<span class="hide">${char}</span>`).join('');

          this.label.querySelectorAll('span').forEach((span, j) => {
            setTimeout(() => {
              span.classList.remove("hide");
            }, j * delay);
          });
        }, steps * delay);
      }
    }

    updateCustomLabel(event) {
      this.label.innerHTML = event.target.value;

      this.updateProductFormInputValue();

      if (this.scentCustomNamed == false){
        this.progressBarItems[this.progressBarItems.length - 1].classList.remove("__inactive");
        this.progressBarItems[(this.progressBarItems.length - 1) - 3].classList.remove("__inactive");
        this.scentCustomNamed = true;
      }
    }
  } 

  customElements.define('buff-by-you', BuffByYou);
}
